export const DataSourceUtil = {
  googleSpreadsheetUrl: (googleSpreadsheetId: string, googleSheetId: number): `https://${string}` =>
    `https://docs.google.com/spreadsheets/d/${googleSpreadsheetId}/edit#gid=${googleSheetId}`,

  googleAppsScriptUrl: (googleAppsScriptId: string): `https://${string}` =>
    `https://script.google.com/u/0/home/projects/${googleAppsScriptId}`,
};
